// 公共配置文件,所有公共配置都应从此处导出
let app_key_map = {
    8954099:'商机助理版',
    2540440:'web端版',
    1236050:'入端版',
}
let WXAppKey = 'wx6449127ba1ca2ca8'
if(process.env.VUE_APP_ENV == 'test'){
    WXAppKey = 'wx6449127ba1ca2ca8'
}
let config = {
    APP_KEY: WXAppKey, //APP_KEY
    app_key_map,
    WebOS: window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i)?'wx':'web', // 是否为微信浏览器环境
    SystemOS: navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)?'IOS':'Other', // 系统环境 IOS 或 其他
}
export default config;